import { EOnboaringFormStep } from '@constants';
import { Form } from 'antd';
import { useEffect, useState } from 'react';

import { getStepValidationConfig } from '../config/stepValidationConfig';

import { useOnboardingFormLogic, useRegionalization } from '@/hooks';
import { useMySubscriptions, useUserOnboarding } from '@/store';

export const useFormValidation = () => {
  const form = Form.useFormInstance();
  const { currentStep, stepIndex, loadingAfterContract, allSteps } = useOnboardingFormLogic();
  const { planificableSubscriptions = [] } = useMySubscriptions();
  const { uni: uniRegionConfig } = useRegionalization();
  const { isContractSigned } = useUserOnboarding();

  const [isValid, setIsValid] = useState(false);
  const formValues = Form.useWatch([], form);

  const isContractStep = currentStep === EOnboaringFormStep.SIGN_CONTRACT;
  const previousStep = allSteps[stepIndex - 1];
  const isPreviousStepContract = previousStep === EOnboaringFormStep.SIGN_CONTRACT;
  const goBackHidden = stepIndex === 0 || loadingAfterContract || isPreviousStepContract;

  useEffect(() => {
    const validateStep = async () => {
      if (currentStep === EOnboaringFormStep.SUBJECT_NOTES) {
        const subjects = form.getFieldValue(['userInfo', 'subjects']) || [];
        const hasValidNotes = subjects.every((s: { note: number | string | undefined }) => {
          if (!s.note) {
            return true;
          }
          const note = Number(s.note);
          const { min, max } = uniRegionConfig.grade;
          const isValidNote = !isNaN(note) && note >= min && note <= max;
          return isValidNote;
        });

        setIsValid(hasValidNotes);
        return;
      }

      const stepConfig = getStepValidationConfig()[currentStep];
      if (!stepConfig) {
        setIsValid(true);
        return;
      }

      try {
        await form.validateFields(stepConfig.requiredFields, { validateOnly: true });
        setIsValid(true);
      } catch (error) {
        setIsValid(false);
      }
    };

    validateStep();
  }, [currentStep, formValues, form, planificableSubscriptions]);

  const isButtonDisabled = isContractStep ? !isContractSigned : !isValid;

  return { isButtonDisabled, goBackHidden };
};
